import { BattlePass } from "interfaces/battle-pass.ts";

export const isBattlePassActive = (battlePass: BattlePass): boolean => {
  const now = new Date().getTime();
  return battlePass.begin <= now && now <= battlePass.finish;
};
